import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import iconSprite from '../../../assets/icon-sprite.svg';
import { updateBusiness, fetchBusiness } from '../../actions/account';
import { sendOTP } from '../../actions/auth';

class OnboardInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  async componentDidMount() {
    try {
      const { user } = this.props;
      const response = await sendOTP({ phone_number: user.phone_number, type: user?.type });
      if (response.status !== 'success') throw new Error(response?.message);
      toast.success(response?.message);
    } catch (error) {
      toast.error(error.response?.data?.message || error.response?.statusText
        || error.message
        || 'Seems like something went wrong with your request. Please try again.');
    }
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = (e) => {
    const { onClose, fetchBusiness } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        const response = await updateBusiness(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        fetchBusiness();
        onClose?.();
      } catch (error) {
        this.setState({ loading: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { visible, onClose = function $() {}, business, user} = this.props;
    const { loading } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form action="" className="modal-form" onSubmit={this.handleSubmit}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addDetailsLabel">Add business info</h5>
              <button type="button" className="close" onClick={onClose}>
                <svg width="48" height="48">
                  <use xlinkHref={iconSprite + '#close-icon'}></use>
                </svg>
              </button>
            </div>
            <div className="modal-body">

              {
                user?.type !== 'broker' && (
                <div className="form-group">
                  <label htmlFor="bvn" className="form-label">BVN</label>
                  <input
                  type="number"
                  className="form-control"
                  id="bvn"
                  onChange={this.handleOnChange}
                  name="bvn" />
                  <div className="form-text error-message">
                    <p>BVN is required.</p>
                  </div>
                </div>
                )
              }
             
              <div className="form-group">
                <label htmlFor="registration_number" className="form-label">Business Registration Number</label>
                <input
                  type="number"
                  className="form-control"
                  id="registration_number"
                  onChange={this.handleOnChange}
                  defaultValue={business.registration_number}
                  name="registration_number" />
                <div className="form-text error-message">
                  <p>Business Registration Number is required.</p>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="registration_date" className="form-label">Date of Registration</label>
                <input
                  type="date"
                  className="form-control"
                  id="registration_date"
                  defaultValue={business.registration_date?.split('T')[0]}
                  onChange={this.handleOnChange}
                  name="registration_date" />
                <div className="form-text error-message">
                  <p>Date of Registration is required.</p>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="otp" className="form-label">Enter OTP sent to your phone</label>
                <input
                  type="number"
                  id="otp"
                  name="otp"
                  className="form-control"
                  onChange={this.handleOnChange}
                  required />
                <div className="form-text error-message">
                  <p>OTP is required.</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary" disabled={!!loading}>{loading || 'Add'}</button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  user: state.account?.user || {},
});

const mapDispatchToProps = {
  fetchBusiness,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnboardInfo);
